/* unplugin-vue-components disabled */import { render } from "./tenant-ai.vue?vue&type=template&id=56c269ee"
import script from "./tenant-ai.vue?vue&type=script&lang=js"
export * from "./tenant-ai.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/tenants/settings/tenant-ai.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "56c269ee"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('56c269ee', __exports__)) {
    api.reload('56c269ee', __exports__)
  }
  
  module.hot.accept("./tenant-ai.vue?vue&type=template&id=56c269ee", () => {
    api.rerender('56c269ee', render)
  })

}


export default __exports__